import { useAppDispatch, useAppSelector } from '@/Hook/hooks';
import { getNotification } from '@/Redux/Ducks/inboxSlice';
import { setActiveTab } from '@/Redux/Ducks/tabSlice';
import AlignTimeAgo from '@/UI/BaseComponents/AlignTimeAgo';
import BaseMethods from 'AlignBaseUI/BaseMethods';
import { ControlTranslation } from 'AlignComponents';
import { useEffect } from 'react';
import { Nav, NavDropdown } from 'react-bootstrap';
import { FaCheckCircle, FaCloudDownloadAlt } from 'react-icons/fa';
import { MdMailOutline } from 'react-icons/md';
import { useHistory } from 'react-router';

const ActiveApproval = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { inbox } = useAppSelector((state) => ({
    inbox: {
      inbox: state.Inbox.messages?.["/approval/active"]?.data || [],
      inboxLoaded: !state.Inbox.messages?.["/approval/active"]?.dataLoading,
    },
  }));

  useEffect(() => {
    if (!inbox.inboxLoaded) {
      dispatch(getNotification({ key: "/approval/active", reload: true, searchParam: '' }));
    }
  }, [inbox.inboxLoaded])

  const routeToSpecific = (routeTo: string) => {
    history.push(routeTo);
    dispatch(setActiveTab(""));
  }

  const handleNotificationClick = () => {
    dispatch(getNotification({ key: "/approval/active", reload: true, searchParam: '' }));
  }

  const inboxDropdown = (
    <div>
      <MdMailOutline size={24} onClick={handleNotificationClick} />
      {
        inbox.inbox.length >= 1 ? (
          <span className="count">
            {inbox.inbox.length}
          </span>
        ) : null
      }
    </div>
  )

  const openMessage = (message: any) => {
    history.push({
      pathname: "approval/active",
      state: { activeMessage: message }
    });
  }


  return (
    <NavDropdown title={inboxDropdown} className="inbox-dropdown">
      {
        inbox.inboxLoaded ? inbox.inbox.length >= 1 ? (
          <>
            <NavDropdown.ItemText className="inbox-header" role="button">
              <ControlTranslation system={true} controlId="lblmyactiveapprovals" /> ({inbox.inbox.length})

              <Nav.Link className="view-all" role="button" onClick={() => routeToSpecific("approval/active")}>
                <ControlTranslation system={true} controlId="lblviewall" />
              </Nav.Link>
            </NavDropdown.ItemText>
            <NavDropdown.Divider />
            <div style={{ height: "100%", overflow: "auto" }}>
              {
                inbox.inbox.map((x, i) => (
                  <div key={i} className="inbox-item" onClick={() => openMessage(x)}>
                    <img src={BaseMethods.getUserPhoto(x.userphoto)} alt="" className="rounded-circle thumb-xs" />
                    <div className="text">
                      <h6> {x.messageuserfullname}</h6>
                      <span>{x.subject}</span>
                    </div>
                    <AlignTimeAgo className="ms-auto" date={BaseMethods.convertUTCDateToLocal(x.credate).toString()} />
                  </div>
                ))
              }
            </div>
          </>
        ) :
          <div className="inbox-info">
            <FaCheckCircle size="40" />
            <h6>
              No Active Approvals
              <ControlTranslation system={true} controlId="lblnoactiveapprovals" />
            </h6>
          </div>
          : (
            <div className="inbox-info">
              <FaCloudDownloadAlt size="40" />
              <h6>
                <ControlTranslation system={true} controlId="lblfetchingapprovals" />
              </h6>
            </div>
          )
      }



    </NavDropdown>
  )
}

export default ActiveApproval;